import { ApplicationContext } from '../../../base';
import { MessageQuery } from './conversationMessageQuery';

export const PREFIX = ['conversations', 'message'];

export function getMessageQueryKey(context: ApplicationContext, query: MessageQuery) {
    return [...PREFIX, context.principal?.id, query.thread.id];
}
